import { ConstanteGlobal } from "../config/constanteGlobal";
import { FiltroBasico } from "../models/basico";
import { ModeloSopBusinessUnit } from "../models/sopBusinessUnit";
import { Repositorio } from "./repositorio";

export class FiltroSopBusinesUnit extends FiltroBasico<ModeloSopBusinessUnit> implements Partial<ModeloSopBusinessUnit> {
  
}

export class RepositorioSopBusinessUnit extends Repositorio<ModeloSopBusinessUnit> {
  constructor() {
    super(ConstanteGlobal.SOP_BUSINESS_UNIT);
  }
}
